import React from 'react'
import linkStyles from './Reviews.module.css'
import Google from '../../images/Google-Reviews.png'
import Yelp from '../../images/yelp-5-stars.png'
import Trip from '../../images/tripadvisor-logo-png-9.png'
import Stars from '../../images/5-stars.png'
import {Box, Button, Grid, Typography} from '@mui/material'
import { Link } from 'react-router-dom'
export const Reviews = () => {
  let glink = "https://www.google.com/search?q=diablo+escapes+google+reviews&client=ubuntu&hs=L60&channel=fs&sxsrf=ALiCzsbArJ8pzNj-s40FQOj0HfXIfwy87w%3A1666139732988&ei=VEZPY5TNO-7aptQPsZqzwAY&ved=0ahUKEwiUx7iXhuv6AhVurYkEHTHNDGgQ4dUDCA4&uact=5&oq=diablo+escapes+google+reviews&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIFCCEQoAE6BwgjELADECc6DQgAEEcQ1gQQsAMQyQM6CggAEEcQ1gQQsAM6CAgAEJIDELADOgQIIxAnOgsILhCABBDHARCvAToFCAAQgAQ6BQgAEIYDOgUIIRCrAjoHCCEQoAEQCjoICCEQFhAeEB1KBAhBGABKBAhGGABQ2QFY6w1glg5oAXABeACAAccBiAGZEJIBBDAuMTSYAQCgAQHIAQrAAQE&sclient=gws-wiz-serp#lrd=0x808561edc967c1a1:0x123f58a04af6faff,1,,,"
  let ylink = "https://www.yelp.com/biz/diablo-escapes-walnut-creek"
  let tlink = "https://www.tripadvisor.co.nz/Attraction_Review-g33235-d23548760-Reviews-Diablo_Escapes-Walnut_Creek_California.html#REVIEWS"
  return (
    <Grid container padding = {4} className={linkStyles.reviews}>
      <Grid item xs={12}  pb={5}>
          <Typography color="white" variant="h5" textAlign={"center"} fontFamily="Copperplate">
            See why we are the top rated VR Escape Room in the Bay Area!
          </Typography>
        </Grid>
      <Grid md = {4} display= {{xs:"none",md:"flex"}}style={{paddingBottom:"100px",justifyContent:"center"}} >
            <a style={{maxWidth:"50%",objectFit:"contain"}}target = "_blank" href={glink}> <img src = {Google} alt = "Google Reviews" style={{maxWidth:"100%",objectFit:"contain"}}/></a>
        </Grid>
        <Grid  md = {4} display= {{xs:"none",md:"flex"}} style={{paddingBottom:"100px", justifyContent:"center"}}>
        <a style={{maxWidth:"50%",objectFit:"contain"}}target = "_blank" href={ylink}><img src = {Yelp} alt = "Yelp Reviews" style={{maxWidth:"100%", objectFit:"contain"}}/></a>
        </Grid>
        <Grid md = {4} display= {{xs:"none",md:"flex"}}style={{paddingBottom:"100px", justifyContent:"center"}}>
        <a style={{maxWidth:"70%",objectFit:"contain"}}target = "_blank" href={tlink}><img src = {Trip} alt = "Tripadvisor Reviews" style={{maxWidth:"100%", objectFit:"contain"}}/></a>
        </Grid>
        <Grid  md = {4} display= {{xs:"none",md:"block"}} padding={"0px 25px"} > 
            <img src = {Stars} alt = "stars" style={{maxWidth:"50%"}}/>
            <Typography color="white" fontFamily={"Sans-Serif"}>
            "The game felt so real. You get to experience problems that you can’t simulate in real life. 
            Can’t wait to go back and try the other games. We thought it was even better than the non VR escape rooms we have been too."
            <br></br><br></br>-Jackie Mendez Local Guide <br></br><br></br>
            <Button target = "_blank" href={glink} variant="outlined"  style={{borderRadius:"20px", color:"white"}}><Typography fontFamily={"Copperplate"}>Read more reviews</Typography></Button>
            </Typography>
        </Grid>
        <Grid  md = {4} display= {{xs:"none",md:"block"}} padding={"0px 25px"}>
          <img src = {Stars} alt = "stars" style={{maxWidth:"50%"}}/>
            <Typography color="white" fontFamily={"Sans-Serif"}>
            "At first I was a little skeptical. I didn't even know that a VR escape room was a thing! 
            Best decision I made! It was great and SO fun. Not to mention, wonderful service... 
            The graphics were spot on. 12/10!" <br></br><br></br>
            - Jazmine Douglass <br></br><br></br>
            <Button target = "_blank" href={ylink} variant="outlined"  style={{borderRadius:"20px", color:"white"}}><Typography fontFamily={"Copperplate"}>Read more reviews</Typography></Button>
            </Typography>
        </Grid>
        <Grid  md = {4} display= {{xs:"none",md:"block"}} padding={"0px 25px"}>
          <img src = {Stars} alt = "stars" style={{maxWidth:"50%"}}/>
            <Typography color="white" fontFamily={"Sans-Serif"}>
            "Having done many escape rooms in the past, I was skeptical about VR rooms. 
            The VR aspect was super high quality and it was surreal being able to walk 
            around and interact with the virtual room and each other."<br></br><br></br>
              -Dean Reich Local Guide <br></br><br></br> 
              <Button target = "_blank" href={tlink} variant="outlined"  style={{borderRadius:"20px", color:"white"}}><Typography fontFamily={"Copperplate"}>Read more reviews</Typography></Button>
            </Typography>
        </Grid>
        <Grid item xs ={12} md = {4} display= {{md:"none"}} pb={"100px"}>
            <Box textAlign={"center"}>
            <a style={{maxWidth:"50%",objectFit:"contain"}}target = "_blank" href={glink}><img src = {Google} alt = "Google Reviews" style={{maxWidth:"50%", objectFit:"contain"}}/></a>
            </Box>
            <Box position="relative" bottom={"0%"}>
              <img src = {Stars} alt = "stars" style={{maxWidth:"25%"}}/>
              <Typography color="white" fontFamily={"Sans-Serif"}>
              "The game felt so real. You get to experience problems that you can’t simulate in real life. 
              Can’t wait to go back and try the other games. We thought it was even better than the non VR escape rooms we have been too."
              <br></br><br></br>-Jackie Mendez Local Guide <br></br><br></br>        
              <Button target = "_blank" href={glink} variant="outlined"  style={{borderRadius:"20px", color:"white"}}><Typography fontFamily={"Copperplate"}>Read more reviews</Typography></Button>
              </Typography>
            </Box>
        </Grid>
        <Grid item xs ={12} md = {4} display= {{md:"none"}} pb={"100px"}>
            <Box textAlign={"center"}>
            <a style={{maxWidth:"50%",objectFit:"contain"}}target = "_blank" href={ylink}><img src = {Yelp} alt = "Yelp Reviews" style={{maxWidth:"50%", objectFit:"contain"}}/></a>
            </Box>
            <Box position="relative" >
            <img src = {Stars} alt = "stars" style={{maxWidth:"25%"}}/>
              <Typography color="white" fontFamily={"Sans-Serif"}>
              "At first I was a little skeptical. I didn't even know that a VR escape room was a thing! 
              Best decision I made! It was great and SO fun. Not to mention, wonderful service... 
              The graphics were spot on. 12/10!" <br></br><br></br>
              - Jazmine Douglass <br></br><br></br>
              <Button target = "_blank" href={ylink} variant="outlined"  style={{borderRadius:"20px", color:"white"}}><Typography fontFamily={"Copperplate"}>Read more reviews</Typography></Button>
              </Typography>
            </Box>
        </Grid>
        <Grid item xs ={12} md = {4} display= {{md:"none"}} pb={"100px"}>
            <Box textAlign={"center"}>
            <a style={{maxWidth:"50%",objectFit:"contain"}}target = "_blank" href={tlink}><img src = {Trip} alt = "Tripadvisor Reviews" style={{maxWidth:"70%", objectFit:"contain"}}/></a>
            </Box>
            <Box>
              <img src = {Stars} alt = "stars" style={{maxWidth:"25%"}}/>
              <Typography color="white" fontFamily={"Sans-Serif"}>
              "Having done many escape rooms in the past, I was skeptical about VR rooms. 
              The VR aspect was super high quality and it was surreal being able to walk 
              around and interact with the virtual room and each other." <br></br><br></br>
              -Dean Reich Local Guide <br></br><br></br> 
              <Button target = "_blank" href={tlink} variant="outlined"  style={{borderRadius:"20px", color:"white"}}><Typography fontFamily={"Copperplate"}>Read more reviews</Typography></Button>
              </Typography>
            </Box>
        </Grid>

    </Grid>
  )
}
